/** Indique si le seed de démonstration est autorisé (désactivé par défaut). */
export const DEMO_SEED_OPT_IN_KEY = 'nexxus_demo_seed_opt_in';

export function isDemoSeedEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_DEMO_SEED === 'true';
}

/** Opt-in utilisateur (case cochée sur l’écran d’activation). */
export function isDemoSeedOptIn(): boolean {
  try {
    return sessionStorage.getItem(DEMO_SEED_OPT_IN_KEY) === '1';
  } catch {
    return false;
  }
}

export function setDemoSeedOptIn(enabled: boolean): void {
  try {
    if (enabled) sessionStorage.setItem(DEMO_SEED_OPT_IN_KEY, '1');
    else sessionStorage.removeItem(DEMO_SEED_OPT_IN_KEY);
  } catch {
    /* ignore */
  }
}

export function canLoadDemoSeed(): boolean {
  return isDemoSeedEnabled() || isDemoSeedOptIn();
}
